import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export function useDictList() {
  const { t } = useI18n();

  const yesNoList = computed(() => {
    return [
      {
        value: 'undefined',
        label: t('ui.filters.select.all'),
      },
      {
        label: t('ui.filters.select.no'),
        value: false,
      },
      {
        label: t('ui.filters.select.yes'),
        value: true,
      },
    ];
  });
  const allAutoManualList = computed(() => {
    return [
      {
        value: 'undefined',
        label: t('ui.filters.select.all'),
      },
      {
        label: t('ui.filters.select.auto'),
        value: 'auto',
      },
      {
        label: t('ui.filters.select.manual'),
        value: 'manual',
      },
    ];
  });
  const allAutoManualListBoolean = computed(() => {
    return [
      {
        value: 'undefined',
        label: t('ui.filters.select.all'),
      },
      {
        label: t('ui.filters.select.auto'),
        value: true,
      },
      {
        label: t('ui.filters.select.manual'),
        value: false,
      },
    ];
  });
  const autoManualList = computed(() => {
    return [
      {
        label: t('ui.filters.select.auto'),
        value: 'auto',
      },
      {
        label: t('ui.filters.select.manual'),
        value: 'manual',
      }
    ];
  });

  return { allAutoManualList, yesNoList, autoManualList, allAutoManualListBoolean };
}
